import React from "react";
import Testimonials from "../components/testimonials/Testimonials";
import axios from "axios";
import { useState } from "react";
// import BreadcrumbsHeader from "./common/BreadcrumbsHeader";
import BreadcrumbsHeader from "../components/breadcrumbs/BreadcrumbsHeader";
import { FaArrowRight } from "react-icons/fa";

const Careers = () => {
    const [formData, setFormData] = useState({});

  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setFormData({ 
      ...formData, 
      [e.target.name]: e.target.value 
    });
  };


    const handleSubmit = async (e) => {
      e.preventDefault();
      setLoading(true);
      setMessage("");

      try {
    
          const response = await axios.post(
          "https://erp.isolsgroup.com/api/v1/module/crm/leads/web_lead?id=101591&api_token=a1b962d0c1fb87354b47c32c88929ea2",
          formData,
          { headers: { "Content-Type": "application/json" } }
        );

        if (response.data && response.data._resultMessage) {
          setMessage(
            response.data._resultMessage.replace("{{ID}}", response.data.id)
          );
        } else {
          setMessage("Form submitted successfully!");
        }


      }  catch (error) {
        console.error(error);
        setMessage("Error submitting form. Please try again later.");
      } finally {
        setLoading(false);
      }
      
  };


  return (
    <div className="page-container">
      {/* Breadcrumbs Section */}
            <BreadcrumbsHeader 
        title="Careers" 
        backgroundImage="/images/header/careers3.jpg" 
      />


      {/* Opportunities Section */}
      <section className="section-abouts">
        <div className="container">
          <div className="row">
            <div className="col-xs-12 col-sm-12">
              <div className="b-mod-heading text-center">
                <p className="first-heading font-secondary wow fadeInDown">
                  Opportunities Available Only For
                </p>
                <h2 className="heading-line line-right customColor customPseudoElBg wow fadeIn">
                  <strong>Passionate &amp; Fueled people with Dreams</strong>
                </h2>
                <p className="second-heading font-additional">
                  With a sense of great delight we welcome everyone who believe in bringing a change and creating an ever lasting impact, to be the part of our young, energetic &amp; experienced rising team.
                  <br />
                  Like minded team spirit is a fuel that allows us to ascent towards our goals. Here, at ISOLS Group, we're constantly looking for the talented passionate people, who are interested to unveil a booming successful career. 
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* 4 Things We Look For Section */}
      <section className="section-about1">
        <div className="container-bg-additional relative clearfix">
          <div className="b-services-bg-filter customBgColor"></div>
          <div className="b-featured-services">
            <div className="container">
              <div className="row">
                <div className="col-xs-12 col-sm-7 col-md-6 col-lg-7">
                  <div className="featured-services-left wow slideInLeft">
                    <div className="b-f-s-info">
                      <h3 className="f-s-title">
                        4 Things We Look For
                        <br />
                        Do You Have it in You?
                      </h3>
                      <p>
                        As ISOLS stands for Intuitive Souls, we look for enthusiastic geeks and vibrant personalities who has the thirst for ultimate and don't want to settle down.
                        If you feel that you are instumental to bring a change and innovation is your thirst area then proceed further to apply &amp; test the same.
                      </p>
                      <a href="#career" className="btn btn-default-arrow btn-sm">
                        <FaArrowRight />   Become a proud ISOLIAN
                      </a>
                    </div>
                  </div>
                </div>
                <div className="col-xs-11 col-sm-5 col-md-5 col-lg-5">
                  <div className="featured-services-right wow fadeIn career">
                    <div className="b-work-steps">
                      {[ 
                        { title: "HONESTY", desc: "Being honest with your own self, work and organisation." },
                        { title: "DEDICATION", desc: "Dedicated &amp; determined to make an ever lasting impact." },
                        { title: "DREAMS & ACTIONS", desc: "Must carry the visualisation to dream big and ready to act for it." },
                        { title: "LOVE & PASSION", desc: "Must carry the love &amp; passion for the work you do and must have fundamental grip on the same." },
                      ].map((item, idx) => (
                        <div className="b-services-item" key={idx}>
                          <div className="services-icon">
                            <div className="circle-0">
                              <div className="circle-1">
                                <div className="circle-2"></div>
                              </div>
                            </div>
                          </div>
                          <div className="services-text">
                            <h6 className="services-title customPseudoElBg font-secondary text-uppercase">
                              <span className="customColor">{idx + 1}.</span> {item.title}
                            </h6>
                            <p>{item.desc}</p>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Career Form Section */}
       <section className="form" id="career">
      <div className="container">
        <div className="row">
          {/* Left Image */}
          <div className="col-xs-12 col-sm-7 col-md-6 col-lg-6">
            <div className="career1">
              <img
                src="https://www.isolsgroup.com/images/c1.png"
                alt="Career at ISOLS Group"
                width="100%"
              />
            </div>
          </div>

          {/* Right Side Form */}
          <div className="col-xs-12 col-sm-7 col-md-6 col-lg-6 right-side wow slideInUp">
            <form onSubmit={handleSubmit}
              className="leadforms-form"
              is_init="true"
              style={{
                border: "5px solid #e6e6e6",
                padding: "40px 30px 30px",
                maxWidth: "700px",
              }}
            >
              <div
                className="leadforms-form-title"
                style={{
                  fontSize: "22px",
                  fontWeight: "600",
                  color: "#ff9600",
                  marginBottom: "10px",
                }}
              >
                Are You Talented? Join the Rockstar Team
              </div>

              <input type="hidden" name="manager_id" value="0" />
              <input type="hidden" name="pipeline_id" value="16" />
              <input type="hidden" name="source_id" value="36" />
              <input
                type="hidden"
                name="name"
                onChange={handleChange}
                value="New Job Application Received | Isols Group Website"
              />
              <input
                type="hidden"
                id="leadforms_host"
                value="https://erp.isolsgroup.com/"
              />
              <textarea name="nspm" onChange={handleChange} style={{ display: "none" }}></textarea>

              {/* Name */}
              <div className="leadforms-row">
                <label className="leadforms-label" htmlFor="leadforms_contact_name">
                  Name <span className="leadforms-required">*</span>
                </label>
                <input
                  type="text"
                  required
                  onChange={handleChange}
                  id="leadforms_contact_name"
                  placeholder="Your Name"
                  name="Your_Name"
                  className="leadforms-input"
                />
              </div>

              {/* Phone & Email */}
              <div className="leadforms-row">
                <table
                  width="100%"
                  className="leadforms-table-rows"
                  style={{ borderCollapse: "collapse", marginBottom: 0 }}
                >
                  <tbody>
                    <tr>
                      <td width="48%">
                        <label
                          className="leadforms-label"
                          htmlFor="leadforms_contact_phone"
                        >
                          Mobile Number <span className="leadforms-required">*</span>
                        </label>
                        <input
                          type="text"
                          required
                          onChange={handleChange}
                          id="leadforms_contact_phone"
                          placeholder="Your Mobile Number"
                          name="Your_Phone"
                          className="leadforms-input"
                        />
                      </td>
                      <td width="4%">&nbsp;</td>
                      <td width="48%">
                        <label
                          className="leadforms-label"
                          htmlFor="leadforms_contact_email"
                        >
                          E-mail <span className="leadforms-required">*</span>
                        </label>
                        <input
                          type="text"
                          required
                          onChange={handleChange}
                          id="leadforms_contact_email"
                          placeholder="Your Email"
                          name="Your_Email"
                          className="leadforms-input"
                        />
                      </td>
                    </tr>
                    <tr>
                      <td width="48%">
                        <label
                          className="leadforms-label"
                          htmlFor="leadforms_description"
                        >
                          Current Address / City <span className="leadforms-required">*</span>
                        </label>
                        <input
                          id="leadforms_description"
                          required
                          onChange={handleChange}
                          style={{ width: "100%" }}
                          name="Address"
                          className="leadforms-input"
                        />
                      </td>
                      <td width="4%">&nbsp;</td>
                      <td width="48%">
                        <label
                          className="leadforms-label"
                          htmlFor="leadforms_description"
                        >
                          What value you can contribute?{" "}
                          <span className="leadforms-required">*</span>
                        </label>
                        <input
                          required
                          onChange={handleChange}
                          style={{ width: "100%" }}
                          name="What_value_you_can_contribute"
                          className="leadforms-input"
                        />
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>

              {/* Job, Experience, Notice, Work Mode */}
              <div className="leadforms-row">
                <table
                  width="100%"
                  className="leadforms-table-rows"
                  style={{ borderCollapse: "collapse", marginBottom: 0 }}
                >
                  <tbody>
                    <tr>
                      <td width="48%">
                        <label className="leadforms-label" htmlFor="leadforms_contact_company">
                          Current Job Position <span className="leadforms-required">*</span>
                        </label>
                        <select
                          required
                          onChange={handleChange}
                          id="leadforms_contact_company"
                          name="Job_Position"
                          className="leadforms-input"
                        >
                          <option>---Select---</option>
                          <option>Business Development Executive (Kolkata, India)</option>
                          <option>Business Development Executive (Lucknow, India)</option>
                        </select>
                      </td>
                      <td width="4%">&nbsp;</td>
                      <td width="48%">
                        <label className="leadforms-label" htmlFor="leadforms_contact_company">
                          Total Years of Experience <span className="leadforms-required">*</span>
                        </label>
                        <select
                          required
                          id="leadforms_contact_company"
                          name="Experience"
                          onChange={handleChange}
                          className="leadforms-input"
                        >
                          <option>---Select---</option>
                          <option>Fresher</option>
                          <option>1 years</option>
                          <option>2 years</option>
                          <option>3 years</option>
                          <option>4 years</option>
                          <option>5 years</option>
                          <option>6 years</option>
                          <option>7 years</option>
                          <option>8 years</option>
                          <option>9 years</option>
                          <option>10+ years</option>
                        </select>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>

              {/* Notice, Work Mode, Qualification, University */}
              <div className="leadforms-row">
                <table
                  width="100%"
                  className="leadforms-table-rows"
                  style={{ borderCollapse: "collapse", marginBottom: 0 }}
                >
                  <tbody>
                    <tr>
                      <td width="48%">
                        <label className="leadforms-label" htmlFor="leadforms_contact_company">
                          Notice Period <span className="leadforms-required">*</span>
                        </label>
                        <select
                          required
                          id="leadforms_contact_company"
                          name="Notice_Period"
                          onChange={handleChange}
                          className="leadforms-input"
                        >
                          <option>---Select---</option>
                          <option>Immediate</option>
                          <option>15 days</option>
                          <option>30 days</option>
                          <option>60 days</option>
                          <option>90 days</option>
                        </select>
                      </td>
                      <td width="4%">&nbsp;</td>
                      <td width="48%">
                        <label className="leadforms-label" htmlFor="leadforms_contact_company">
                          Work Mode <span className="leadforms-required">*</span>
                        </label>
                        <select
                          required
                          id="leadforms_contact_company"
                          name="Work_Mode"
                          onChange={handleChange}
                          className="leadforms-input"
                        >
                          <option>---Select---</option>
                          <option>Work from Office</option>
                          <option>Hybrid</option>
                          <option>Remote only</option>
                          <option>Comfortable with any</option>
                        </select>
                      </td>
                    </tr>
                    <tr>
                      <td width="48%">
                        <label className="leadforms-label" htmlFor="leadforms_contact_company">
                          Highest Education Qualification <span className="leadforms-required">*</span>
                        </label>
                        <input type="text" onChange={handleChange} required name="Qualification" className="leadforms-input" />
                      </td>
                      <td width="4%">&nbsp;</td>
                      <td width="48%">
                        <label className="leadforms-label" htmlFor="leadforms_contact_company">
                          University/Institution Name <span className="leadforms-required">*</span>
                        </label>
                        <input type="text" onChange={handleChange} required name="University" className="leadforms-input" />
                      </td>
                    </tr>
                    <tr>
                      <td width="48%">
                        <label className="leadforms-label" htmlFor="leadforms_contact_company">
                          LinkedIn Profile Link
                        </label>
                        <input type="text" onChange={handleChange} name="LinkedIn_Profile_Link" className="leadforms-input" />
                      </td>
                      <td width="4%">&nbsp;</td>
                      <td width="48%">
                        <label className="leadforms-label" htmlFor="leadforms_contact_company">
                          Resume/CV Link <span className="leadforms-required">*</span>
                        </label>
                        <input type="text" name="Resume_Link" onChange={handleChange}className="leadforms-input" />
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>

               {message && (
                    <div
                      className="flowlu-notification"
                      style={{ marginTop: "10px", fontWeight: "bold", color: message.includes("Error") ? "red" : "green" }}
                    >
                      {message}
                    </div>
                  )}

              {/* Submit Button */}
              <div className="leadforms-row leadforms-row-submit text-center">
                <button
                  className="leadforms-submit leadforms-btn"
                  disabled={loading}
                  style={{
                    background: "#e56714",
                    border: "1px solid #e56714",
                    color: "#fff",
                    marginTop: "20px",
                    textAlign: "center",
                    padding: "10px 20px",
                    borderRadius: "5px",            }}
                >
                     {loading ? "Submitting..." : "Submit"}
                </button>
              </div>
            </form>
          </div>


        </div>
      </div>
    </section>

      {/* Testimonials Section */}
      <Testimonials />
    </div>
  );
};

export default Careers;
